var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import { BASE_FONT_BOLD_WEIGHT, BASE_FONT_FAMILY, FONT_LINE_HEIGHT_M, FONT_SIZE_M, BASE_BORDER_WIDTH, SPACING_S, SPACING_M } from "../../helpers";
import { TabList } from "../../TabList";
import { ACTION_VIEW, Dialog, DIALOG_SIZE } from "../../Dialog";
import { KeyCode } from "../../helpers/keyCode";
var PageHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n    border-bottom: ", " solid ", ";\n"], ["\n    padding: ", " ", ";\n    border-bottom: ", " solid ", ";\n"])), SPACING_S, SPACING_M, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderMain;
});
var PageTitle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n"], ["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
}, BASE_FONT_FAMILY, FONT_SIZE_M, BASE_FONT_BOLD_WEIGHT, FONT_LINE_HEIGHT_M);
var PageDescription = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0 0 0;\n"], ["\n    margin: ", " 0 0 0;\n"])), SPACING_S);
var TabPanelBody = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding: ", ";\n    overflow: auto;\n\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n"], ["\n    box-sizing: border-box;\n    padding: ", ";\n    overflow: auto;\n\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n"])), function (_a) {
    var hasContentPadding = _a.hasContentPadding;
    return (hasContentPadding ? "" + SPACING_M : '0');
});
var TabPanel = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    overflow: hidden;\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    overflow: hidden;\n"])));
var WindowBody = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    background-color: #fff;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n\n    flex: 1;\n    overflow: auto;\n\n    display: flex;\n    flex-direction: row;\n\n    position: relative;\n"], ["\n    background-color: #fff;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n\n    flex: 1;\n    overflow: auto;\n\n    display: flex;\n    flex-direction: row;\n\n    position: relative;\n"])));
var DEFAULT_ACTIONS_TEXTS = {
    previous: 'Previous',
    next: 'Next',
    submit: 'Finish',
    cancel: 'Cancel'
};
var WizardStateless = /** @class */ (function (_super) {
    __extends(WizardStateless, _super);
    function WizardStateless() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refDialog = React.createRef();
        return _this;
    }
    WizardStateless.renderTabPanelHeader = function (elem) {
        return (React.createElement(PageHeader, null,
            elem.props.panelTitle && React.createElement(PageTitle, null, elem.props.panelTitle),
            elem.props.panelDescription && (React.createElement(PageDescription, null, elem.props.panelDescription))));
    };
    WizardStateless.prototype.renderTabList = function (dataSelectorId) {
        var _a = this.props, steps = _a.steps, _b = _a.isEdit, isEdit = _b === void 0 ? false : _b, activeStep = _a.activeStep, setStep = _a.setStep;
        return (React.createElement(TabList, { "data-selector-id": dataSelectorId + "-tabs", items: React.Children.map(steps, function (elem, idx) {
                return {
                    id: idx.toString(),
                    active: idx === activeStep,
                    disabled: elem.props.disabled || (!isEdit && idx > activeStep),
                    onClick: function () { return setStep(idx); },
                    title: elem.props.title
                };
            }) }));
    };
    WizardStateless.prototype.renderTabPanel = function () {
        var _a = this.props, onSubmit = _a.onSubmit, steps = _a.steps, activeStep = _a.activeStep;
        return (
        /* eslint-disable react/no-array-index-key */
        React.createElement(TabPanel, null, React.Children.map(steps, function (elem, idx) {
            var cloneElem = React.cloneElement(elem, { onSubmit: onSubmit });
            if (idx === activeStep) {
                return (React.createElement(React.Fragment, { key: idx },
                    (elem.props.panelTitle || elem.props.panelDescription) &&
                        WizardStateless.renderTabPanelHeader(cloneElem),
                    React.createElement(TabPanelBody, { hasContentPadding: cloneElem.props.hasContentPadding }, cloneElem)));
            }
            return null;
        }))
        /* eslint-enable */
        );
    };
    WizardStateless.prototype.componentDidUpdate = function (prevProps) {
        var _a;
        if (this.props.activeStep !== prevProps.activeStep) {
            try {
                // eslint-disable-next-line react/no-find-dom-node
                (_a = findDOMNode(this.refDialog.current)) === null || _a === void 0 ? void 0 : _a.focus();
            }
            catch (e) {
                // no-op
            }
        }
    };
    WizardStateless.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, title = _a.title, _b = _a.width, width = _b === void 0 ? '750px' : _b, _c = _a.height, height = _c === void 0 ? '450px' : _c, steps = _a.steps, actionsTextsProp = _a.actionsTexts, activeStep = _a.activeStep, setStep = _a.setStep, onSubmitClick = _a.onSubmitClick, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, isPending = _a.isPending, _e = _a.canClose, canClose = _e === void 0 ? true : _e, _f = _a.prevIsDisabled, prevIsDisabled = _f === void 0 ? false : _f, _g = _a.nextIsDisabled, nextIsDisabled = _g === void 0 ? false : _g, secondaryActions = _a.secondaryActions, onEnterKeyDown = _a.onEnterKeyDown, rest = __rest(_a, ["onClose", "title", "width", "height", "steps", "actionsTexts", "activeStep", "setStep", "onSubmitClick", "isLoading", "isPending", "canClose", "prevIsDisabled", "nextIsDisabled", "secondaryActions", "onEnterKeyDown"]);
        var actionsTexts = __assign(__assign({}, DEFAULT_ACTIONS_TEXTS), actionsTextsProp);
        var dataSelectorId = rest['data-selector-id'] || 'wizard-stateless';
        return (React.createElement(Dialog, { "data-selector-id": dataSelectorId, ref: this.refDialog, onRequestClose: onClose, header: title, loading: isLoading, pending: isPending, movable: true, size: width || height
                ? { width: width || DIALOG_SIZE.auto, height: height || DIALOG_SIZE.auto }
                : undefined, hasSpacing: false, canClose: canClose, onKeyPress: function (e) {
                if (e.keyCode === KeyCode.Enter) {
                    onEnterKeyDown === null || onEnterKeyDown === void 0 ? void 0 : onEnterKeyDown(e);
                }
            }, actions: [
                activeStep !== 0 && {
                    text: actionsTexts.previous,
                    view: ACTION_VIEW.alternate,
                    disabled: isLoading || prevIsDisabled,
                    onClick: function () { return setStep(activeStep - 1); }
                },
                {
                    text: activeStep === React.Children.count(steps) - 1
                        ? actionsTexts.submit
                        : actionsTexts.next,
                    disabled: isLoading || nextIsDisabled,
                    view: ACTION_VIEW.primary,
                    onClick: function () { return onSubmitClick(activeStep); }
                },
                {
                    text: actionsTexts.cancel,
                    disabled: isLoading,
                    view: ACTION_VIEW.secondary,
                    onClick: onClose
                }
            ], secondaryActions: secondaryActions },
            React.createElement(WindowBody, null,
                this.renderTabList(dataSelectorId),
                this.renderTabPanel())));
    };
    return WizardStateless;
}(Component));
export { WizardStateless };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=WizardStateless.js.map